// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const containAuthorityResponseSchema = z.object({
  "user_id": z.string().uuid(),
  "standing_revoked": z.number().int().min(0),
  "grants_revoked": z.number().int().min(0),
  "principals_suspended": z.number().int().min(0),
  "partial": z.boolean(),
  "failed_legs": z.array(z.enum(["standing_delegations", "live_grants", "owned_principals"]))
});

export const userRefSchema = z.object({
  "id": z.string().uuid(),
  "display_name": z.string(),
  "primary_email": z.string().optional()
});

export const userRefsResponseSchema = z.object({
  "refs": z.array(userRefSchema)
});

export const userPushTokenSchema = z.object({
  "id": z.string().uuid(),
  "platform": z.enum(["ios", "android"]),
  "app_id": z.string().optional(),
  "device_model": z.string().optional(),
  "os_version": z.string().optional(),
  "app_version": z.string().optional(),
  "friendly_name": z.string().optional(),
  "notifications_enabled": z.boolean(),
  "status": z.enum(["active", "revoked"]),
  "created_at": z.string().datetime({ offset: true }),
  "last_seen_at": z.string().datetime({ offset: true }).optional(),
  "last_notified_at": z.string().datetime({ offset: true }).optional()
});

export const userPushTokensResponseSchema = z.object({
  "items": z.array(userPushTokenSchema)
});

export const devicePostureVerdictSchema = z.object({
  "verdict": z.enum(["allow", "deny"]),
  "provider": z.string(),
  "reason_class": z.string().optional(),
  "observed_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true })
});

export const userDeviceIdentitySchema = z.object({
  "id": z.string().uuid(),
  "name": z.string(),
  "state": z.enum(["created", "certified", "active", "suspended", "quarantined"]),
  "credential_id": z.string().uuid(),
  "created_at": z.string().datetime({ offset: true }),
  "posture": devicePostureVerdictSchema.optional()
});

export const userDeviceIdentitiesResponseSchema = z.object({
  "devices": z.array(userDeviceIdentitySchema)
});

export const userObservedDeviceSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "device_type": z.enum(["browser", "mobile", "desktop", "cli", "unknown"]),
  "friendly_name": z.string().optional(),
  "user_agent": z.string().optional(),
  "status": z.enum(["active", "revoked"]),
  "created_at": z.string().datetime({ offset: true }),
  "last_seen_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional()
});
